import { BlueBirdTheme } from "@kitbird/core";
import styled from "styled-components";

const { gray } = BlueBirdTheme.colors;

export const FileWrapper = styled.div`
  display: grid;
  grid-template-columns: 50% auto;
  gap: 20px;
  :hover {
    cursor: pointer;
    background-color: ${gray.background};
  }
`;

export const FileItem = styled.div`
  border-radius: 8px;
  padding: 12px 20px;
  border: ${`1px solid ${gray.line}`};
  display: grid;
  grid-template-columns: 10% calc(80% - 24px) 10%;
  gap: 12px;
`;

export const DescriptionCol = styled.div<{ $isEllipsis?: boolean; }>`
  ${(props) => props.$isEllipsis && `
  max-height: 40px;
  max-width: 200px;

  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  :first-child::after {
    content: ". . .";
    word-spacing: -1.5px;
  }
  `}
`;
